<script setup>
import { computed, ref } from 'vue';
import { useStore, useMapGetter } from 'dashboard/composables/store';
import { useI18n } from 'vue-i18n';
import { useAlert } from 'dashboard/composables';

import Dialog from 'dashboard/components-next/dialog/Dialog.vue';

// Owner order 2026-09-29: a campaign that is already sending can be stopped
// from the card. The server marks it completed and freezes the unreached
// list, so "resend to unreached" can finish it later.
const props = defineProps({
  selectedCampaign: {
    type: Object,
    default: null,
  },
});

const { t } = useI18n();
const store = useStore();
const dialogRef = ref(null);

const uiFlags = useMapGetter('campaigns/getUIFlags');
const isStopping = computed(() => Boolean(uiFlags.value?.isStopping));

const handleDialogConfirm = async () => {
  if (!props.selectedCampaign?.id) return;
  if (isStopping.value) return;

  try {
    await store.dispatch('campaigns/stop', props.selectedCampaign.id);
    useAlert(t('CAMPAIGN.WHATSAPP.STOP.API.SUCCESS_MESSAGE'));
    dialogRef.value?.close();
  } catch (error) {
    useAlert(
      error?.response?.data?.error ||
        t('CAMPAIGN.WHATSAPP.STOP.API.ERROR_MESSAGE')
    );
  }
};

defineExpose({ dialogRef });
</script>

<template>
  <Dialog
    ref="dialogRef"
    type="alert"
    :title="t('CAMPAIGN.WHATSAPP.STOP.TITLE')"
    :description="t('CAMPAIGN.WHATSAPP.STOP.DESCRIPTION')"
    :confirm-button-label="t('CAMPAIGN.WHATSAPP.STOP.CONFIRM')"
    :is-loading="isStopping"
    :disable-confirm-button="isStopping"
    @confirm="handleDialogConfirm"
  />
</template>
